export function CardCollectionSearchControl(props = {}) {
    const {
        isEnabled = false,
        placeholder = 'Enter keywords',
        label = 'search'
    } = props
    return isEnabled
        ? (<label htmlFor="collection_search_input"
            className="col-start-2 gap-4 grid grid-col-2-maxcontent items-center row-start-1">
            <span className="font-semibold text-black text-xs uppercase">{label}</span>
            <div className="border-0 border-b grid grid-cols-1fr-maxcontent grid-flow-col items-center p-0">
                <input type="search" placeholder={placeholder} className="border-0 p-0" />
                <button class="text-blue">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" className="fill-current w-4 h-4"><path d="M49.598 45.298l-13.4-13.3c2.7-3.8 4.1-8.6 3.4-13.7-1.2-8.6-8.2-15.4-16.9-16.2-11.8-1.2-21.8 8.8-20.6 20.7.8 8.6 7.6 15.7 16.2 16.9 5.1.7 9.9-.7 13.7-3.4l13.3 13.3c.6.6 1.5.6 2.1 0l2.1-2.1c.6-.6.6-1.6.1-2.2zm-41.6-24.4c0-7.1 5.8-12.9 12.9-12.9 7.1 0 12.9 5.8 12.9 12.9 0 7.1-5.8 12.9-12.9 12.9-7.1 0-12.9-5.7-12.9-12.9z" /></svg>
                </button>
            </div>
        </label>)
        : null
}

export default CardCollectionSearchControl